import { PDFDownloadLink } from '@react-pdf/renderer'
import React from 'react'
import DownloadPackingList from './DownloadPackingList'
import { CreateButton } from '../../../../../Components/Utils/Buttons'

function PdfLinkPackingList({headers,data,fileName}) {
    return (
        <PDFDownloadLink document={<DownloadPackingList header={headers} data={data} />} fileName={fileName}>
        {({ blob, url, loading, error }) =>
          loading ? (
            "..."
          ) : (
            <CreateButton svg={false} label="Download as PDF" />
          )
        }
      </PDFDownloadLink>
      )
    }

export default PdfLinkPackingList